module.exports = __webpack_public_path__ + "static/img/archivorosa-1.27e02b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/archivorosa-1.jpg
// module id = kZMV
// module chunks = 1